import {
  GraduationCap,
  Compass,
  HeartHandshake,
  BadgeDollarSign,
  School,
  Flag,
  Lightbulb,
  Users,
  Activity,
} from "lucide-react";

export const LOGO_URL = "/assets/logo.png";

export const MISSION =
  "We use sports as a platform to change lives by providing the resources, mentorship, and opportunities youth athletes need to reach their full potential. We are building Louisiana's premier youth organization, developing athletes on and off the field through education, character, and community.";

export const VISION =
  "To become the leading youth organization in Louisiana, setting the standard for athletic excellence, academic success, character development, and community impact.";

export const DIFFERENTIATOR = "The only national team in South Louisiana";

export const LEAGUE =
  "The Louisiana Ducks compete in the American Youth Football League, the biggest league in the nation. Its National Championships are the largest youth football tournament in the world, and we built this program to win on that stage.";

export const PROGRAMS = [
  { name: "Academic Advising", icon: GraduationCap, description: "A tutoring system flexible enough to fit every athlete, in every subject area." },
  { name: "Behavior Intervention Support", icon: Compass, description: "Individualized plans that help young athletes reset, refocus, and grow." },
  { name: "Community Service Opportunities", icon: HeartHandshake, description: "Giving back across St. Charles Parish and the New Orleans metro area." },
  { name: "Financial Assistance & Scholarships", icon: BadgeDollarSign, description: "Sponsorship opportunities for qualifying athletes, so cost never benches a kid." },
  { name: "College Exposure Experiences", icon: School, description: "Camps and showcases that put Ducks athletes in front of college programs." },
  { name: "Leadership Development", icon: Flag, description: "Building captains on the field and leaders off it." },
  { name: "Life Skills Training", icon: Lightbulb, description: "Practical skills for school, work, and life beyond the game." },
  { name: "Mentorship Program", icon: Users, description: "Mentors who invest in every athlete's future, on and off the field." },
  { name: "Health & Wellness", icon: Activity, description: "Keeping young athletes strong, healthy, and ready to compete." },
];

export const DIRECTORS = [
  { name: "Allen Pittman", role: "Executive Director", photo: "/assets/allen-pittman.jpg", focus: "Organization leadership, partnerships, and vision", bio: "Allen Pittman brings over a decade of experience developing athletes at every level. A former All-American at Nicholls State, he went on to coach at two of the most dominant programs in high school football — winning a state championship with Destrehan High School and coaching at Archbishop Rummel High School. He is also the founder of 4th Quarter Performance, which has produced multiple Division I and professional athletes. As Executive Director, Allen leads the Ducks' vision of building champions on the field and leaders off it." },
  { name: "Dontell Johnson", role: "Athletic Director", photo: "/assets/dontell-johnson.jpg", focus: "Athletic program leadership and player development, on and off the field", bio: "A former state champion at Lutcher High School, Dontell Johnson knows what it takes to win — and how to build winners. He brings multiple years of experience coordinating youth camps, fundraising, and sponsorships, and has been a pillar in his community by hosting free football camps for local kids. As Athletic Director, Dontell leads player development and program operations, making sure every Duck gets the chance to grow on and off the field." },
];

export const COACHES = [
  { name: "Allen Pittman", role: "Head Coach", photo: "/assets/allen-pittman.jpg", focus: "Program culture and on-field excellence" },
  { name: "Dontell Johnson", role: "Offensive Coordinator", photo: "/assets/dontell-johnson.jpg", focus: "Offensive scheme and player development" },
];

export const DONATION_AMOUNTS = [
  { label: "$10", lookup_key: "donate_10" },
  { label: "$25", lookup_key: "donate_25" },
  { label: "$50", lookup_key: "donate_50" },
  { label: "$100", lookup_key: "donate_100" },
  { label: "$250", lookup_key: "donate_250" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/programs", label: "Programs" },
  { to: "/directors", label: "Directors" },
  { to: "/coaches", label: "Coaches" },
  { to: "/schedule", label: "Schedule" },
  { to: "/sponsors", label: "Sponsors" },
  { to: "/join", label: "Join" },
];
